import { createSelector } from 'reselect';
import { getHomeSpacesForView } from '@app/selectors/home';
import { getAllSpaces } from '@core/selectors/space/space.selectors';

export const getHomeRecentSpaces = createSelector(
  [
    getHomeSpacesForView,
    getAllSpaces,
    (state: any) => state.spaceSelector?.recentlyViewedSpaces?.spaceList || [],
  ],
  (spacesForView, allSpaces, recentSpaceList) => {
    const spacesForViewMap = new Map(
      (spacesForView || []).map((s: any) => [s.objectId || s.id, s])
    );
    const allSpacesMap = allSpaces || {};

    return recentSpaceList
      .filter((recentSpace: any) => {
        if (spacesForViewMap.has(recentSpace.spaceId)) {
          return true;
        }

        // Known membership for the other home view role — exclude.
        // Do not trust baked-in isStaffAccess from a pre-hydration fetch.
        if (allSpacesMap[recentSpace.spaceId]) {
          return false;
        }

        // Not in classRooms yet (true staff-access / external) — keep.
        return true;
      })
      .map((recentSpace: any) => {
        const space = spacesForViewMap.get(recentSpace.spaceId);

        if (!space) {
          return {
            id: recentSpace.spaceId,
            objectId: recentSpace.spaceId,
            name: recentSpace.name,
            avatar: recentSpace.avatar,
            isStarred: !!recentSpace.isStarred,
            lastNavigation: recentSpace.lastNavigation,
            isStaffAccess: true,
          };
        }

        return {
          ...space,
          isStarred: !!space.isStarred,
          lastNavigation: recentSpace.lastNavigation,
          isStaffAccess: !!recentSpace.isStaffAccess,
        };
      });
  }
);
